module.exports = __webpack_public_path__ + "static/img/hddd1.69e27a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/hddd1.png
// module id = 322
// module chunks = 0